import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { Interests, Skills, MembershipFormData, Leadership, LandingDTOModel, FilterModel, Site } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
@Component({
  selector: 'app-bpg-list',
  templateUrl: './bpg-list.component.html',
  styleUrls: ['./bpg-list.component.css']
})

export class BpgListComponent implements OnInit {
  selectedBpg: any[] = [];
  bpgList: any[] = [];
  savedData: any = JSON.parse(sessionStorage.getItem('MembershipData'));
  formData: MembershipFormData[];
  interestList: Interests[];
  skillsList: Skills[];
  siteList: Site;
  leadershipList: Leadership = new Leadership();
  message: string;
  demographicsList: any[] = [];
  otherSKills: string;
  membershipDetails: any[] = [];
  userId = 1;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: any[] = [];
  savedMembershipForm: any;
  landingDTOModel: LandingDTOModel = new LandingDTOModel();
  siteId1: any = localStorage.getItem('userSiteId');
  filter: FilterModel = new FilterModel();
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  nobpgfound = false;
  virtualBpg: boolean;

  corporateType: string;
  isCorporateUser = false;
  showLeadership = false; 
  bpgName : any;
  roleList : any[] = [];
  chairs : any = [] ;
  viceChairs : any = []  ;
  communicationsChairs: any= [] ;
  financeChairs: any  = [];
 leadershipObj :  any ;
 newList = {};
 finalList : any[] = [];
 
  /**
   * @class BpgListComponent
   * @constructor
   */
  constructor(private readonly membershipService: BpgMembershipService,
    private readonly router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    
    private readonly environment: EnvironmentConfiguration) { }

  ngOnInit() {
    localStorage.setItem('oneSkill', 'false');
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    window.scrollTo(0, 0);

    localStorage.removeItem('searchedEventsCaledarItems');
    this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }  
 




    this.formData = [];
    if (this.savedData === null) {
      this.savedData = "default msg"
    }

    this.spinnerService.show();
    if (this.savedData[0].virtualBpg !== undefined) {
      this.virtualBpg = this.savedData[0].virtualBpg;
    } else {
      this.virtualBpg = undefined;
    }
    if (this.savedData[0].siteFormData !== undefined) {
      this.siteList = this.savedData[0].siteFormData;
    } else {
      this.siteList = null;
    }
    if (this.savedData[0].interestFormData !== undefined) {
      this.interestList = this.savedData[0].interestFormData;
    } else {
      this.interestList = [];
    }
    if (this.savedData[0].skillsFormData !== undefined) {
      this.skillsList = this.savedData[0].skillsFormData;
    } else {
      this.skillsList = [];
    }
    if (this.savedData[0].leadershipFormData !== undefined) {
      this.leadershipList = this.savedData[0].leadershipFormData;
    } else {
      this.leadershipList = null;
    }
    if (this.savedData[0].otherSkillsFormData !== undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }
    this.getBpgDetails();
  }

  


  /** To async the service call to get the bpg list with selected bpgs
   * @class BpgListComponent
   * @method getBpgDetails
   */
  async getBpgDetails() {
    if (this.virtualBpg) {
      await this.getVirtualBpgs();
    } else {
      await this.getBpgs();
    }
  }

  /** To async the service call to get the bpg list
   * @class BpgListComponent
   * @method getBpgs
   */
  async getBpgs() {
    this.filter.siteId = String(this.siteList.siteId);
    this.landingDTOModel.filter = this.filter;
    await this.membershipService.getAllBpg(this.landingDTOModel).toPromise().then(async data => {
      
      this.bpgList = data;

     
     
      if (this.bpgList.length > 0) {
        this.nobpgfound = false;
      }
      else {
        this.nobpgfound = true;
      }
      await this.getSelectedBpgs();
    }, err => {
      this.spinnerService.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To async the service call to get the bpg list of default site
   * @class BpgListComponent
   * @method getBpgs
   */
  async getVirtualBpgs() {
    const params = `${this.siteList.siteId}/${this.siteId1}/${this.loginData.userId}`;
    await this.membershipService.getAllVirtualBpg(params).toPromise().then(async data => {
      this.bpgList = data;
      if (this.bpgList.length > 0) {
        this.nobpgfound = false;
      } else {
        this.nobpgfound = true;
      }
      await this.getSelectedBpgs();
    }, err => {
      this.spinnerService.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }
  /** To async the service call to get the selected bpg list
   * @class BpgListComponent
   * @method getSelectedBpgs
   */
  async getSelectedBpgs() {
    await this.membershipService.retrieveDetailsOfMembership(this.loginData.userId).toPromise().then(data => {
      this.membershipDetails = data;
      sessionStorage.setItem("previousMembershipDetails", JSON.stringify(this.membershipDetails));

      if (this.savedData[0].bpgFormData !== undefined && this.savedData[0].bpgFormData.length > 0) {
        for (let i = 0, len = this.bpgList.length; i < len; i++) {
          for (let j = 0, len = this.savedData[0].bpgFormData.length; j < len; j++) {
            if (this.bpgList[i].bpgId === this.savedData[0].bpgFormData[j].bpgId) {
              this.bpgList[i].checked = true;
              this.selectedBpg.push(this.bpgList[i]);
            }
          }
        }
      }
      if (this.savedData[0].bpgFormData !== undefined && this.savedData[0].bpgFormData.length > 0) {
        for (let j = 0 ; j < this.savedData[0].bpgFormData.length ; j++)
        { 
           const bpgname = this.savedData[0].bpgFormData[j].bpgName;
        if(this.selectedBpg[j].bpgName === bpgname)
          {this.selectedBpg[j].showLeadership =true;
          this.chairs[bpgname] = this.savedData[0].bpgFormData[j].chairs;
          this.selectedBpg[j].chairs = this.savedData[0].bpgFormData[j].chairs;
          this.viceChairs[bpgname] = this.savedData[0].bpgFormData[j].viceChairs;
          this.selectedBpg[j].viceChairs = this.savedData[0].bpgFormData[j].viceChairs;
          this.communicationsChairs[bpgname] = this.savedData[0].bpgFormData[j].communicationsChairs;
          this.selectedBpg[j].communicationsChairs = this.savedData[0].bpgFormData[j].communicationsChairs;
          this.financeChairs[bpgname] = this.savedData[0].bpgFormData[j].financeChairs;
          this.selectedBpg[j].financeChairs = this.savedData[0].bpgFormData[j].financeChairs;
        }
        }
    }

    if(this.membershipDetails['selectedBpg'].length > 0 && (this.membershipDetails['selectedBpg']!== undefined && this.membershipDetails['selectedBpg']!= null) &&  this.savedData[0].bpgFormData.length===0)
    {
      const selectList = this.bpgList;
      
      for(const bpg of this.membershipDetails['selectedBpg'])
      { 
        for(const select of selectList)
        { 
  
          if(bpg.bpgName === select.bpgName)
          {
            select.chairs = bpg.isChair;
            select.viceChairs = bpg.isViceChair;
            select.communicationsChairs = bpg.isCommunicationChair;
            select.financeChairs = bpg.isFinanceChair;
            this.chairs[select.bpgName] = bpg.isChair;
            this.viceChairs[select.bpgName] = bpg.isViceChair;
            this.communicationsChairs[select.bpgName]  = bpg.isCommunicationChair;
            this.financeChairs[select.bpgName] = bpg.isFinanceChair;
            select.showLeadership=true;
            select.checked=true;
            this.selectedBpg.push(select)
          }
        }

      }
    }
      if (this.membershipDetails['bpgIds'].length > 0) {
        for (let i = 0, len = this.bpgList.length; i < len; i++) {
          for (let j = 0, len = this.membershipDetails['bpgIds'].length; j < len; j++) {
            if (this.bpgList[i].bpgId === this.membershipDetails['bpgIds'][j]) {
              this.bpgList[i].checked = true;
              this.bpgList[i].showLeadership = true;
           
              this.selectedBpg.push(this.bpgList[i]);
            }
          }
        }
      }

  
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To send data to next page
   * @class BpgListComponent
   * @method sendData
   */
  public sendData() {

    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    this.router.navigate(['membership/interests']);
    window.scrollTo(0, 0);


  }



assignroles(event,data)
{
const bpgName = data.bpgName;
if(event.target.checked)
{
  for (const bpg of this.selectedBpg)
  {
    if(bpgName === bpg.bpgName)
    {
    if(this.chairs[bpgName]){
      bpg.chairs = true;
    }
    if(this.viceChairs[bpgName]){
      bpg.viceChairs = true;
    }
    if(this.communicationsChairs[bpgName]){
      bpg.communicationsChairs = true;
    }
    if(this.financeChairs[bpgName]){
      bpg.financeChairs = true;
    }
    }
  }
}

else{
  for (const bpg1 of this.selectedBpg)
    {
    if(bpgName === bpg1.bpgName)
    {
    if(!this.chairs[bpgName]){
      bpg1.chairs = false;
    }
    if(!this.viceChairs[bpgName]){
      bpg1.viceChairs = false;
    }
    if(!this.communicationsChairs[bpgName]){
      bpg1.communicationsChairs = false;
    }
    if(!this.financeChairs[bpgName]){
      bpg1.financeChairs = false;
    }
    }
  }
 
}
}


  /** to select the checkbox
   * @class BpgListComponent
   * @method toggleCheckbox
   */
  toggleCheckbox(event, data) {  

    if (event.target.checked) {
      this.selectedBpg.push(data);
      for (let i = 0 ; i < this.bpgList.length ; i++)
      {
 
       if( this.bpgList[i].bpgName === data.bpgName)
       {
         this.bpgList[i] = Object.assign(this.bpgList[i], {
           'showLeadership' : true,
         })
     
 }}
    
      for(let j = 0 ; j < this.selectedBpg.length ; j++)
      {
        if( this.selectedBpg[j].bpgName === data.bpgName){
          this.selectedBpg[j] = Object.assign(this.selectedBpg[j], {
            chairs : false,communicationsChairs: false , financeChairs :false, viceChairs : false
  })
        }
      }
     
 
   } else {
      const index: number = this.selectedBpg.indexOf(data);
      if (index !== -1) {
      

        this.selectedBpg.splice(index, 1);
       for (let i = 0; i < this.bpgList.length ; i++){
        if(this.bpgList[i].bpgName === data.bpgName)
        {
         this.bpgList[i] = Object.assign(this.bpgList[i], {
            'showLeadership' : false,
      }) }
   
     
      }
     
      }
    }

  }

  /** To send data to previous page
   * @class BpgListComponent
   * @method redirectToSite
   */
  public redirectToSite() {
    localStorage.setItem('status', 'true');
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0);
  }
}
